<template>
  <section id="newsList" class="overflow-x-hidden">
      <div class="heading-wraper text-center">
         <h4>{{newsData.title}}</h4>
         <hr class="heading-devider gradient-orange">
        </div>
      <div class="row">
        <div class="col-md-6 col-md-news-img">
          <div class="image-wraper">
            <!-- <img class="img-responsive" src="images/news1.jpg" alt=""> -->
          </div>
        </div>
        <div class="col-md-6 col-md-news">
          <div class="customer-support-content  sm-padding-top-bottom-50-75">
            
            <div class="panel-group" id="accordion">
                <div class="panel" v-for="(item, index) in newsData.content" :key="index">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a data-toggle="collapse" data-parent="#accordion" :href="'#collapseOne'+index">
                            {{item.title}}
                            </a>
                        </h4>
                    </div>
                    <div :id="'collapseOne'+index" class="panel-collapse collapse ">
                        <div class="panel-body pre-scrollable" v-html="item.content">
                            </div>
                    </div>
                </div>
                
                
            </div>
          </div>
        </div>
      </div>
      
    </section>
</template>
<script>
export default {
  name: 'news',
  props:['newsData']
}
</script>


// WEBPACK FOOTER //
// src/components/news.vue